import React, { useEffect, useState } from 'react';
import MuxPlayer from '@mux/mux-player-react';

/** Core */
import Buttons from '../../core/Buttons';

/** Iconos */
import LogoAtresmedia from '../../../../assets/images/logoatresmedia.svg';
import Back from '../../../../assets/images/svg/Back.svg';
import Warning from '../../../../assets/images/svg/Warning.svg';
import Document from '../../../../assets/images/svg/documento.svg';

/** Estilos */
import {
  StyledLinksIndexUser,
  StyledHeaderIcon,
  StyledTitle,
  StyledText,
  StyledSpan,
  StyledImageSmall,
  StyledImageBig,
  StyledCenterButton,
  StyledIcon,
  StyledUl,
  StyledCheckbox
} from './style';

/** Imágenes */
import OnBoarding1 from '../../../../assets/images/png/onboarding1.png';
import OnBoarding2 from '../../../../assets/images/png/onboarding2.png';
import OnBoarding3 from '../../../../assets/images/png/onboarding3.png';
import OnBoarding4 from '../../../../assets/images/png/onboarding4.png';
import OnBoarding5 from '../../../../assets/images/png/onboarding5.png';
import OnBoarding6 from '../../../../assets/images/png/onboarding6.png';
import OnBoarding7 from '../../../../assets/images/png/onboarding7.png';

import { getUserDetails, setWelcomePage } from '../../../utils/apiUser';

const LinksIndexUser = props => {
  const { setwelcomePage } = props;
  const [setDataUser] = useState(null);
  const [check, setCheck] = useState(false);

  useEffect(() => {
    getUserDetails().then(user => {
      setDataUser(user);
    });
  }, []);

  /** Confirmar lectura de documentos */
  const checkDocuments = () => {
    setWelcomePage();
    if (setwelcomePage) {
      setwelcomePage(true);
    }
  };

  return (
    <StyledLinksIndexUser>
      <StyledHeaderIcon svg={LogoAtresmedia} />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <MuxPlayer
          streamType="on-demand"
          playbackId="Y5lr32VJYt302wqv57ZjCHLo3bQOX00LIiyXFoQAoXZgo"
          style={{ width: '1239', height: '697px' }}
          poster="https://image.mux.com/Y5lr32VJYt302wqv57ZjCHLo3bQOX00LIiyXFoQAoXZgo/thumbnail.jpg?width=480&fit_mode=pad&time=137"
        />
      </div>
      <div>
        <StyledTitle color="orange">1. Manual de acogida</StyledTitle>
        <StyledText>
          <StyledImageSmall float="left" src={OnBoarding1} alt="OnBoarding1" />
          <StyledSpan color="orange">Tú nos importas</StyledSpan> y a partir de
          hoy formas parte de nuestra historia. Somos mucho más: somos tele,
          somos radio, somos multimedia, somos entretenimiento, cine, series y
          por encima de eso{' '}
          <StyledSpan bold>SOMOS UN EQUIPO HUMANO.</StyledSpan> Si quieres
          conocer un poco más sobre nosotros, aquí puedes encontrar información
          relevante del Grupo Atresmedia, nuestros valores y cultura de empresa,
          funcionamiento del comedor, solicitud de la tarjeta de empleado, plaza
          de PK, información sobre RRHH (nómina, cambio de banco, Plan de
          Formación...), Intranet, etc.
        </StyledText>

        <StyledCenterButton type="button">
          <StyledIcon
            svg={Document}
            size="m"
            stroke="white"
            marginRight="10px"
          />{' '}
          <a
            href="https://intranetapi.atresmedia.com//documents/documents01/2023/05/30/F483BC1E-73C6-44DE-A6F7-74AE1EAE1E28/Manual%20de%20Acogida%202023%20-%20ACTUALIZADO%20A3MIL%2020230530.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Manual de acogida
          </a>
        </StyledCenterButton>
      </div>
      <div>
        <StyledTitle color="red">2. Código de conducta</StyledTitle>
        <StyledText>
          <StyledImageBig
            newHeight="170px"
            newWidth="230px"
            float="right"
            src={OnBoarding2}
            alt="OnBoarding2"
          />
          El Código de Conducta es el elemento principal del Modelo de
          Cumplimiento de Atresmedia. Todos los empleados deben conocer su
          contenido y aplicarlo. Su finalidad es prevenir los riesgos penales,
          así como situaciones y conductas contrarias a las normas aplicables a
          Atresmedia. En <StyledSpan bold>A3Mil</StyledSpan>, en la sección de
          <StyledSpan bold> Cumplimiento Normativo</StyledSpan>, están
          disponibles las normas que integran este modelo. También encontrarás
          <StyledSpan bold> Canal de Consultas y Denuncias</StyledSpan> que
          utilizar en el caso de que quieras hacer alguna consulta sobre la
          aplicación de una norma, así como para comunicar cualquier infracción
          del Modelo, pudiendo hacerlo también de forma anónima y con totales
          garantías de confidencialidad. Junto al canal encontrarás su
          procedimiento regulador.
        </StyledText>
        <StyledImageSmall
          newHeight="48px"
          newWidth="48px"
          float="left"
          src={OnBoarding5}
          alt="OnBoarding5"
        />
        <StyledText marginTop="2rem">
          Si tienes cualquier duda ponte en contacto con el{' '}
          <StyledSpan bold>Responsable de Cumplimiento</StyledSpan>:{' '}
          <a href="mailto:responsable.cumplimiento@atresmedia.com">
            responsable.cumplimiento@atresmedia.com
          </a>
        </StyledText>

        <StyledCenterButton type="button">
          <StyledIcon
            svg={Document}
            size="m"
            stroke="white"
            marginRight="10px"
          />{' '}
          <a
            href="https://intranetapi.atresmedia.com/documents/documents01/2022/06/15/E0E7340D-F6CC-431A-8EE6-44805233EADD/99036_codigo_de_conducta.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Código de conducta
          </a>
        </StyledCenterButton>
      </div>
      <div>
        <StyledTitle color="blue">3. Protección de datos</StyledTitle>
        <StyledText>
          <StyledImageBig
            newHeight="170px"
            newWidth="170px"
            float="right"
            src={OnBoarding3}
            alt="OnBoarding3"
          />
          Todos los empleados deben conocer las normas, políticas y protocolos
          que integran el Modelo de Privacidad de Atresmedia y aplicarlas en su
          actividad profesional y en sus relaciones con colaboradores externos y
          terceros. En la sección de Protección de Datos de A3Mil puedes acceder
          a toda la información sobre el{' '}
          <StyledSpan bold>Modelo, sus políticas y protocolos</StyledSpan>, los
          mecanismos establecidos para su{' '}
          <StyledSpan bold>adecuado funcionamiento</StyledSpan>, así como{' '}
          <StyledSpan bold>recursos formativos</StyledSpan>. En esta sección
          también puedes informarte sobre la{' '}
          <StyledSpan bold>Política de Privacidad</StyledSpan> aplicable a
          empleados. (Documentación disponible en Protección de Datos dentro de
          A3Mil)
        </StyledText>
        <StyledImageSmall float="left" src={OnBoarding4} alt="OnBoarding4" />
        <StyledText marginTop="1.5rem">
          Cualquier aspecto relacionado con la privacidad de los datos y su
          tratamiento debe consultarse con la Delegada de Protección de Datos
          (DPO):{' '}
          <a href="mailto:privacidad@atresmedia.com">
            privacidad@atresmedia.com
          </a>
        </StyledText>
      </div>
      <br />
      <br />
      <br />
      <br />
      <div>
        <StyledTitle color="red">4. Curso cumplimiento normativo</StyledTitle>
        <StyledText>
          <StyledImageBig
            float="right"
            newHeight="161px"
            newWidth="241px"
            src={OnBoarding6}
            alt="OnBoarding6"
          />
          Curso <StyledSpan bold>obligatorio</StyledSpan> sobre los Modelos de
          Cumplimiento y Protección de Datos para conocer su contenido, las
          conductas que conllevan riesgos de incumplimiento y responsabilidad
          para Atresmedia y sus empleados y los mecanismos implantados para
          evitarlos. (Duración estimada 2 horas, modalidad e-learning).
        </StyledText>
        <StyledText>
          Para acceder a esta formación tienes que indicar:
          <ul>
            <li>Usuario: mail corporativo</li>
            <li>Contraseña: DNI (con letra mayúscula)</li>
          </ul>
        </StyledText>
        <StyledText>
          <StyledIcon svg={Back} size="m" marginRight="10px" />{' '}
          <StyledSpan>
            Para más información, ponte en contacto con:{' '}
            <a href="mailto:soporte@onplusformacion.com">
              soporte@onplusformacion.com
            </a>
          </StyledSpan>
        </StyledText>
        <StyledCenterButton type="button">
          <a
            href="https://atresmedia.bdnplus.com/course/view.php?id=22"
            target="_blank"
            rel="noopener noreferrer"
          >
            Acceso Aquí
          </a>
        </StyledCenterButton>
      </div>
      <div>
        <StyledTitle color="orange">5. Curso prevención riesgos</StyledTitle>
        <StyledText>
          <StyledImageBig float="right" src={OnBoarding7} alt="OnBoarding7" />
          Curso <StyledSpan bold>obligatorio</StyledSpan> sobre los riesgos
          laborales de tu puesto de trabajo, las medidas preventivas y las
          medidas de emergencia. (Duración estimada 2 horas, modalidad
          e-learning).
        </StyledText>
        <StyledText>
          <StyledIcon
            svg={Warning}
            size="l"
            marginTop="30px"
            marginRight="60px"
          />{' '}
          Para acceder a esta formación tienes que indicar:
          <StyledUl>
            <li>
              Usuario: DNI (con letra minúscula y cero delante si es necesario)
            </li>
            <li>
              Contraseña: DNI (con letra mayúscula y cero delante si es
              necesario)
            </li>
          </StyledUl>
        </StyledText>
        <StyledImageSmall
          newHeight="48px"
          newWidth="48px"
          float="left"
          src={OnBoarding5}
          alt="OnBoarding4"
        />
        <StyledText marginTop="2rem">
          Para más información, ponte en contacto con:{' '}
          <a href="mailto:atresmedia@smartlearning.global">
            atresmedia@smartlearning.global
          </a>
        </StyledText>
        <StyledCenterButton type="button">
          <a
            href="https://atresmedia.smartlearning.global"
            target="_blank"
            rel="noopener noreferrer"
          >
            Acceso Aquí
          </a>
        </StyledCenterButton>
      </div>
      <form action="#">
        <StyledCheckbox
          value={check}
          onChange={() => setCheck(!check)}
          label="Acepto haber leído toda la información facilitada en esta página así
        como también los documentos que se indican en la misma."
        />
        <div className="form-footer">
          <Buttons
            type="button"
            disabled={!check}
            secondary
            onClick={() => checkDocuments()}
          >
            Continuar
          </Buttons>
        </div>
      </form>
    </StyledLinksIndexUser>
  );
};

export default LinksIndexUser;
